import React, { useState, useEffect } from 'react';
import '../styles.css';
import { connect, useDispatch } from 'react-redux';
import BackButton from '../../SM/COMPONENTS/BackButton';
import { Background } from '../../SM/COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';
import { START_PAGE, YOUTUBE } from '../../HOME/const';
import { goToPage, forceUpdate, GOTO_GAME_PAGE } from '../../HOME/REDUX/actions';
import { HELPED_KEY, SM_GOLD, YOUTUBE_SM } from '../../SM/const';
import PlayIcon from '../../HOME/SVG/PlayIcon';
import { scrollClass, dbget, dbset } from '../../HOME/utils';

const HelpPage = props => {
  const dispatch = useDispatch();
  const [play, setPlay] = useState(false);
  const { fromPage, size, forceUpdate } = props;

  useEffect(() => {
    window.addEventListener('resize', forceUpdate);

    if (fromPage === START_PAGE && size) {
      dbget(HELPED_KEY, response => setPlay(!response));
    }

    return () => {
      window.removeEventListener('resize', forceUpdate);
      dbset(HELPED_KEY, true);
      dispatch({ type: HELPED_KEY });
    };
  }, [fromPage, size, forceUpdate, dispatch]);

  const color = SM_GOLD;

  return (
    <div className="page-root sm-page" style={{ backgroundImage: Background }}>
      <div className={scrollClass} style={{ margin: '25px 10px 55px' }}>
        <div className="sm-help-content">
          <Bullet row="1" />
          <span style={{ gridArea: '1/2', overflow: 'auto' }}>
            Swap the tiles and solve the puzzle in as few steps as possible. The puzzle is solved when all horizontally or vertically{' '}
            <span style={{ color }}>adjacent</span> tiles share <span style={{ color }}>exactly one</span> common attribute ‒ either{' '}
            <span style={{ color }}>same symbol</span> or <span style={{ color }}>same color</span> but <span style={{ color }}>not both</span>.
          </span>
          <Bullet row="3" />
          <span style={{ gridArea: '3/2', overflow: 'auto' }}>
            To swap two tiles, tap the first one to select it and then tap the second one to make the swap.
          </span>
          <Bullet row="5" />
          <span style={{ gridArea: '5/2', overflow: 'auto' }}>
            The swapped tiles <span style={{ color }}>do not</span> have to be adjacent.
          </span>
          <Bullet row="7" />
          <span style={{ gridArea: '7/2', overflow: 'auto' }}>
            Your <span style={{ color }}>grade</span> is based on your average score and the number of times the game is played. Play{' '}
            <span style={{ color }}>ten times</span> or more to get full credit. Good luck!
          </span>
        </div>
      </div>
      {play && (
        <span className="navigation-button" style={{ left: 'initial', right: '10px' }} onClick={() => dispatch(GOTO_GAME_PAGE)}>
          <PlayIcon width="36" color="white" />
        </span>
      )}
      <div className="home-center-button-toolbar">
        <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_SM} />
      </div>
      <BackButton />
      <HomeButton />
    </div>
  );
};

function mapStateToProps({ sm, common }) {
  return { ...sm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, forceUpdate }
)(HelpPage);

const Bullet = props => {
  const area = `${props.row}/1`;
  const color = SM_GOLD;
  return <span style={{ gridArea: area, marginRight: '10px', color }}>•</span>;
};
